import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import EditNews from "./Components/EditNews";
import ScrollHome from "./Components/ScrollHome";
import Upload from "./Components/Upload,";
import ManageAccount from "./Components/SuperAdmin/ManageAccount";
import ProtectedRoute from "./auth/ProtectedRoute";

import LoginButton from "./auth/login-button";
import LogoutButton from "./auth/logout-button";
import { useAuth0 } from "@auth0/auth0-react";
import Alert from "@material-ui/lab/Alert";
import { Collapse } from "@material-ui/core";

function App() {
  const { isAuthenticated } = useAuth0();
  const [isOpen, setIsOpen] = React.useState(true);

  React.useEffect(() => {
    document.getElementsByTagName("title")[0].innerHTML = "News In Seconds";
    setTimeout(() => setIsOpen(false), 6000);
  }, []);

  return (
    <>
      <Switch>
        <Route path="/allNews" exact component={ScrollHome} />

        <Route path="/upload" exact component={Upload} />

        {/* PROTECTED ROUTE - ADMIN*/}
        <ProtectedRoute
          path="/admin/allNews"
          exact
          component={ScrollHome}
          returnTo="/admin"
        />
        <ProtectedRoute
          path="/admin/addNews"
          exact
          component={EditNews}
          returnTo="/admin"
        />

        <ProtectedRoute
          path="/admin/edit/:id"
          exact
          component={EditNews}
          returnTo="/admin"
        />

        {/* PROTECTED ROUTE - SUPERADMIN*/}
        <ProtectedRoute
          path="/superAdmin/allNews"
          exact
          component={() => "SuperAdmin AllNews"}
          returnTo="/superAdmin"
        />

        <ProtectedRoute
          path="/superAdmin/addNews"
          exact
          component={EditNews}
          returnTo="/superAdmin"
        />

        <ProtectedRoute
          path="/superAdmin/edit/:id"
          exact
          component={EditNews}
          returnTo="/superAdmin"
        />

        <ProtectedRoute
          path="/superAdmin/manageAccount**"
          exact
          component={ManageAccount}
          returnTo="/superAdmin"
        />

        <Route
          path="/admin"
          exact
          component={(props) => {
            // console.log(props);
            return (
              <div style={{ backgroundColor: "#dfdfdf" }}>
                {!isAuthenticated ? <LoginButton /> : <LogoutButton />}
                {!props?.location?.state?.authorize && (
                  <Collapse
                    in={isOpen}
                    style={{
                      width: "100%",
                      position: "fixed",
                      top: 0,
                    }}
                  >
                    <Alert
                      style={{
                        margin: "0 auto",
                        width: "65%",
                      }}
                      variant="filled"
                      onClose={() => setIsOpen(false)}
                      severity={props?.location?.state?.severity}
                    >
                      {props?.location?.state?.message}
                    </Alert>
                  </Collapse>
                )}
                <h1>Admin Page</h1>
              </div>
            );
          }}
        />
        <Route
          path="/superAdmin"
          exact
          component={(props) => {
            // console.log(props);
            return (
              <>
                {!isAuthenticated ? <LoginButton /> : <LogoutButton />}
                {!props?.location?.state?.authorize && (
                  <Collapse
                    in={isOpen}
                    style={{
                      width: "100%",
                      position: "fixed",
                      top: 0,
                    }}
                  >
                    <Alert
                      onClose={() => setIsOpen(false)}
                      severity={props?.location?.state?.severity}
                      style={{
                        margin: "0 auto",
                        width: "65%",
                      }}
                    >
                      {props?.location?.state?.message}
                    </Alert>
                  </Collapse>
                )}
                <h1>SuperAdmin Page</h1>
              </>
            );
          }}
        />

        <Redirect from="/" to="/allNews" />
        {/* <Route path="*" component={() => "404 Not Found"} /> */}
      </Switch>
    </>
  );
}

export default App;
